import ArbokApi from "../api/requests/arbok-api";
export const getArbokOriginFullUrl = (pathname) => { var _a; return `${(_a = ArbokApi.getConfig().baseURL) === null || _a === void 0 ? void 0 : _a.replace(/\/+$/, '')}/originals/chat/${pathname}`; };
